<template>
  <div
      :class="[
          'item-row-alignment',
           'button-with-image',
            !disabled && 'item-cursor',
            disabled && 'item-cursor-not-allowed'
      ]"
    :style="btnLayoutStyle"
    @click="onButtonClicked">
    <weex-text :style="textStyle">{{text}}</weex-text>
    <weex-image
      class="item-align-right"
      v-if="imageSrc"
      :src="imageSrc"
      :style="imageStyle"
      ></weex-image>
  </div>
</template>

<script>

  export default {
    name: "ButtonWithImage",
    props: {
      text: {
        type: String,
        required: true
      },

      imageSrc: {
        type: String,
        default: ""
      },

      disabled: {
        type: Boolean,
        default: false
      },

      emitOnDisabled: {
        type: Boolean,
        default: false
      },

      size: {
        type: String,
        default: "medium"
      },

      enabledBtnStyle: {
        type: Object,
        default: function () {
          return {
            backgroundColor: "#ffffff",
            "border-width": "1px",
            "border-color": "gray",
            "border-style": "solid"
          }
        }
      },

      disabledButtonStyle: {
        type: Object,
        default: function () {
          return { 'backgroundColor': '#D9D9D9' }
        }
      },

      enabledTextStyle: {
        type: Object,
        default: function () {
          return { color: '#000000' }
        }
      },

      disableTextStyle: {
        type: Object,
        default: function () {
          return { 'color': '#000000' }
        }
      }
    },

    methods: {
      onButtonClicked() {
        if (!this.disabled || (this.disabled && this.emitOnDisabled)) {
          this.$emit("onButtonClicked");
        }
      }
    },

    computed: {
      btnLayoutStyle() {
        let mrButtonStyle = {};
        if (this.disabled) {
          mrButtonStyle = {
            ...this.btnSizeMap,
            ...this.disabledButtonStyle
          }
        } else {
          mrButtonStyle = {
            ...this.btnSizeMap,
            ...this.enabledBtnStyle
          }
        }
        if (this.imageSrc) {
          mrButtonStyle['padding-left'] = '10px';
        } else {
          mrButtonStyle['justify-content'] = 'center';
        }

        return mrButtonStyle;
      },

      textStyle() {
        let mrTextStyle = {};
        if (this.disabled) {
          mrTextStyle = {
            ...this.fontSize,
            ...this.disableTextStyle
          }
        } else {
          mrTextStyle = {
            ...this.fontSize,
            ...this.enabledTextStyle
          }
        }
        return mrTextStyle;
      },

      btnSizeMap() {
        let width = 60;
        let height = 38;
        if (this.size === "full") {
          width = 100;
          height = 42;
        } else if (this.size === "big") {
          width = 80;
          height = 40;
        } else if (this.size === "medium") {
          width = 60;
          height = 38;
        } else if (this.size === "small") {
          width = 40;
          height = 36;
        }
        return { 'width': width + '%', 'height': height + 'px' };
      },

      imageSizeAsInt() {
        let widthAndHeight = 30;
        if (this.imageSrc) {
          if (this.size === "full") {
            widthAndHeight = 34;
          } else if (this.size === "big") {
            widthAndHeight = 32;
          } else if (this.size === "medium") {
            widthAndHeight = 30;
          } else if (this.size === "small") {
            widthAndHeight = 28;
          }
        } else {
          widthAndHeight = 0;
        }
        return widthAndHeight;
      },

      fontSize() {
        let fontSize = 14;
        if (this.size === "full") {
          fontSize = 16;
        } else if (this.size === "big") {
          fontSize = 15;
        } else if (this.size === "medium") {
          fontSize = 14;
        } else if (this.size === "small") {
          fontSize = 13;
        }
        return { 'fontSize': fontSize + 'px' }
      },

      imageStyle() {
        const widthAndHeight = this.imageSizeAsInt;
        return {
          width: widthAndHeight + "px",
          height: widthAndHeight + "px",
          "margin-right": "5px"
        };
      }
    }
  }

</script>

<style
  scoped
  src="../../assets/style/base.css"></style>

<style>
  .button-with-image {
    padding: 2px;
    border-radius: 12px;
    align-items: center;
    position: relative;
  }
</style>
